import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output, TemplateRef, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgSelectModule } from '@ng-select/ng-select';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { catchError, debounceTime, filter, of, Subject, Subscription, switchMap } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { JobService } from 'src/app/services/job.service';
import { UtilService } from 'src/app/services/util.service';
import { CommonSkeletonComponent } from '../../../../skeleton/common-skeleton/common-skeleton.component';
import { JobCardComponent } from '../../../cards/job-card/job-card.component';
import Swal from 'sweetalert2';
import { NgIconComponent } from '@ng-icons/core';
import { JobsCandidatesSlideFilterComponent } from '../../../jobs-candidates-slide-filter/jobs-candidates-slide-filter.component';
import { JobFilterVerticalTemplateComponent } from '../../../job-module/job-filter-vertical-template/job-filter-vertical-template.component';

@Component({
  selector: 'app-customer-business-joblist',
  standalone: true,
  imports: [CommonModule, FormsModule, MatMenuModule, NgSelectModule, InfiniteScrollModule, CommonSkeletonComponent, JobCardComponent,
    NgIconComponent,
    JobsCandidatesSlideFilterComponent,
    JobFilterVerticalTemplateComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './customer-business-joblist.component.html',
  styleUrls: ['./customer-business-joblist.component.scss']
})
export class CustomerBusinessJoblistComponent implements OnInit, OnDestroy {
  private scrollResetSub?: Subscription;
  // In-flight findOrgJobs request, so a filter Apply / Reset can cancel a
  // superseded page fetch instead of letting its response land on the new
  // list. See jobFilterwithPagenation(force).
  private listSub?: Subscription;
  selecteAllFlag: boolean = false;
  selectionMode: boolean = false;
  response: any[] = [];
  searchNameorEmail: string;
  selectedUser = null;
  selectedstatus: any = [];
  TransferPayload: any = {}
  url = AppSettings.photoUrl;

  payload: any = {
    "limit": 10,
    "searchAfterKey": null,
    "searchContent": "",
    "status": [],
    "organisationId": "",
    "clientType": [],
    "engagementType": [],
    "workMode": [],
    "city": "",
    "state": "",
    "country": "",
    "zipCode": "",
    "experienceFrom": 0,
    "experienceTo": 0,
    "postedFrom": 0,
    "postedTo": 0,
    "publishedBy": [],
    "userTypes": [],
    "businessNetworks": [],
    "memberNetworks": []
  };

  // Slide-out filter wiring (mirrors new-job.component pattern)
  panel: string = 'jobs';
  isFilterOpen: boolean = false;
  entitySent: any = { entity: 'jobs' };
  filterChanges: any = null;
  tempFilterChanges: any = {};
  filterConfig: any = {
    source: this,
    clickHandler: (data) => this.onFilterChange(data)
  };
  userList: any = [];
  userPayload: any = {
    "limit": 1000,
    "page": 0,
    "searchAfterKey": null,
    "statusList": [
      "ACTIVE",
      "INACTIVE",
      "BLOCKED",
      "INITIATED"
    ],
    "groupType": "LISTING",
    "businessId": "",
    "email": localStorage.getItem('userName')
  }

  // Filter-picker employee pipeline. Kept separate from userList /
  // userPayload (which drive the Transfer modal's ng-select and need the full
  // unpaginated list) so the picker can paginate + server-search without
  // breaking Transfer. Backend: subscription/findEmployeeList — a lean,
  // search-friendly endpoint with role/status filters server-side.
  employeeList: any[] = [];
  // Parent-owned loading flag for the My Employees picker. Set true at
  // the start of each findEmployeeList call (toggle ON / search / scroll)
  // and false in the subscribe callback. Bound down to the picker's
  // [isLoading] so the spinner reflects the actual fetch state — the
  // filter template's own isLoading was being prematurely cleared by
  // its ngOnChanges when the parent's empty initial employeeList=[] hit
  // the @Input, which dropped the spinner before the API ever fired.
  employeeLoading: boolean = false;
  employeePayload: any = {
    "limit": 20,
    "searchAfterKey": null,
    "searchContent": "",
    "statusList": ["ACTIVE", "INACTIVE", "BLOCKED", "INITIATED"],
    "roleList": [
      GigsumoConstants.RECRUITER,
      GigsumoConstants.FREELANCE_RECRUITER,
      GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION
    ],
    "businessId": ""
  };
  employeePrevSearchAfterKey: any = null;
  employeeStopScroll: boolean = false;


  statusforSelection = [
    { value: "Active", label: 'Active' },
    { value: "Draft", label: 'Draft' },
    { value: "On Hold", label: 'On Hold' },
    { value: "Filled", label: 'Filled' }
  ];

  isLoading: boolean = false;
  scrollEnable: boolean = true;
  lastSearchAfterKey: any = null;
  jobFoundStatus: string;
  modalRef: any;
  businessData: any = {};
  userId = localStorage.getItem('userId');
  searchTimeout: any;

  searchText = new Subject<string>();
  

  constructor(
    private api: ApiService,
    private _activated_route: ActivatedRoute,
    private JobServicecolor: JobService,
    private modalService: BsModalService,
    private util: UtilService,
    private router: Router,
  ) {
    // Try to get businessData from parent route resolver (admin panel) OR current route resolver (standalone Job Center)
    this._activated_route.parent?.data.subscribe(res => {
      if (res?.data) {
        this.businessData = res.data;
      }
    });
    // Also check current route data for standalone Job Center module
    this._activated_route.data.subscribe(res => {
      if (res?.data) {
        this.businessData = res.data;
      }
    });
  }

  ngOnInit(): void {
    // Reset window scroll to top on initial entry and on every subsequent
    // route change (NavigationEnd also fires when navigating between this
    // page and a sibling menu while the component instance is reused).
    window.scrollTo({ top: 0, left: 0 });
    this.scrollResetSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo({ top: 0, left: 0 });
    });

    this.payload.businessId = this.businessData.id;
    this.payload.userId = this.userId;
    this.payload.organisationId = this.businessData.organisationId;
    // userListAPI() populates this.userList for the Transfer modal.
    // The employee picker list is loaded LAZILY — only when the user
    // actually toggles "My Employees" ON in the filter slider. That
    // fires the @Output (myEmployeesToggled) which calls
    // onMyEmployeesToggled() → getEmployeeListForFilter().
    this.userListAPI();
    // Enacapulation standard I followed this page so don't change
    this.jobFilterwithPagenation();

    this.searchText.pipe(
      debounceTime(100),  
      switchMap(({}) => {   
          this.payload.businessId = this.businessData.id;
          this.payload.userId = this.userId;
          this.payload.organisationId = this.businessData.organisationId;

          return this.api.create('jobs/findOrgJobs', this.payload).pipe(
               
              catchError((error) => {
                  console.log(error);                  
                  return of([]);   
              })
          );
      })
    ).subscribe(
        (res: any) => {
            this.isLoading = false;
            if (res?.data?.jobList?.length > 0) {

              res.data.jobList = res.data.jobList.map(item => ({
                ...item,
                user: {
                  ...(item.user || {}),
                  photo: item?.user?.photo ? this.url + item.user.photo : null
                }
              }));

              this.response = [...this.response, ...res.data.jobList];
              // Am changing to slected all true;
              if (this.selecteAllFlag) {
                this.response = this.response.map(item => ({
                  ...item,
                  transferJob: true,
                  isSelected: true
                }));


              }
              this.lastSearchAfterKey = this.payload.searchAfterKey || null;
              this.payload.searchAfterKey = res.data.searchAfterKey || null;
              this.scrollEnable = true;
              if(res.data.jobList.length<8){
                this.scrollEnable = false;
              }
              this.jobFoundStatus = "";
            } else {
              this.scrollEnable = false;
              this.jobFoundStatus = "Couldn't find any jobs for the applied filters.";
            }

          },
        (error) => {
          this.isLoading = false;
          console.error("Error fetching jobs", error);
        }
    );
  }

  // API calls
  // search api is seperatedly defined if made changes with this method please check search subject also.
  //
  // `force` = "this call supersedes whatever is in flight". Filter Apply /
  // Reset pass it. Without it a rapid second click on the slider's Filter
  // button was silently swallowed by the `isLoading` guard below while
  // onFilterToggle had already cleared `response` and rewritten `payload` --
  // so the older, superseded request's page got appended and the list ended
  // up showing rows that don't match the filters the UI says are applied.
  // Infinite scroll keeps `force = false`: there the guard is what stops
  // duplicate page fetches.
  jobFilterwithPagenation(force: boolean = false) {
    this.payload.businessId = this.businessData.id;
    this.payload.userId = this.userId;
    this.payload.organisationId = this.businessData.organisationId;

    if (force) {
      this.listSub?.unsubscribe();
      this.listSub = undefined;
      this.isLoading = false;
    }

    if (this.isLoading || !this.scrollEnable) return;
    if (this.payload.searchAfterKey === null && this.lastSearchAfterKey === null) {
    } else if (JSON.stringify(this.payload.searchAfterKey) === JSON.stringify(this.lastSearchAfterKey)) {
      this.scrollEnable = false;
      return;
    }

    this.isLoading = true;
    this.listSub = this.api.create('jobs/findOrgJobs', this.payload).subscribe(res => {
      this.isLoading = false;
      console.log('[findOrgJobs] raw response:', res);
      console.log('[findOrgJobs] jobList length:', res?.data?.jobList?.length);
      console.log('[findOrgJobs] first job sample:', res?.data?.jobList?.[0]);
      if (res?.data?.jobList?.length > 0) {

        res.data.jobList = res.data.jobList.map(item => ({
          ...item,
          user: {
            ...(item.user || {}),
            photo: item?.user?.photo ? this.url + item.user.photo : null
          }
        }));

        this.response = [...this.response, ...res.data.jobList];
        console.log('[findOrgJobs] this.response after merge, length:', this.response.length);
        console.log('[findOrgJobs] this.response first item:', this.response[0]);
        // Am changing to slected all true;
        if (this.selecteAllFlag) {
          this.response = this.response.map(item => ({
            ...item,
            transferJob: true,
            isSelected: true
          }));


        }
        this.lastSearchAfterKey = this.payload.searchAfterKey || null;
        this.payload.searchAfterKey = res.data.searchAfterKey || null;
        this.scrollEnable = true;
        if(res.data.jobList.length<8){
          this.scrollEnable = false;
        }
        this.jobFoundStatus = "";
      } else {
        this.scrollEnable = false;
        this.jobFoundStatus = "Couldn't find any jobs for the applied filters.";
      }
    }, error => {
      this.isLoading = false;
      console.error("Error fetching jobs", error);
    });
  }


  userListAPI() {
    this.util.startLoader();
    this.userPayload.businessId = this.businessData.id,
      this.api.create('subscription/findEmployeeBenefitsAllocation', this.userPayload).subscribe(response => {
        this.userList = response?.data?.customerUserAllocationList;
        this.userList = this.filterbyRole(response?.data?.customerUserAllocationList, 'jobs');
        this.userList = this.userList.filter(element => element.planAccessStatus !== "N/A");
        this.util.stopLoader();

        this.userList = this.userList.map(item => ({
          ...item,
          disabled: this.checkUserForEnable(item)
        }));

        console.log(this.userList);
      });
  }

  checkUserForEnable(item: any){
    const selected = this.response.filter(item => item.transferJob === true);
    if (selected.length === 0) return false;
    return selected.every(i => i.jobPostedBy === item.userId);
  }

  // Paginated employee fetch for the "My Employees" filter picker.
  // reset=true on a fresh search; reset=false to append the next page.
  getEmployeeListForFilter(reset: boolean = true) {
    if (reset) {
      this.employeePayload.searchAfterKey = null;
      this.employeePrevSearchAfterKey = null;
      this.employeeStopScroll = false;
      this.employeeList = [];
    }
    this.employeePayload.businessId = this.businessData.id;
    this.employeeLoading = true;
    this.api.create('subscription/findEmployeeList', this.employeePayload)
      .subscribe(
        response => {
          const page = response?.data?.employeeList || [];
          this.employeeList = reset ? page : [...this.employeeList, ...page];
          const nextKey = response?.data?.searchAfterKey;
          if (!page.length || JSON.stringify(nextKey) === JSON.stringify(this.employeePrevSearchAfterKey)) {
            this.employeeStopScroll = true;
          }
          this.employeePrevSearchAfterKey = nextKey;
          this.employeeLoading = false;
        },
        error => {
          console.error('findEmployeeList failed', error);
          // Force a new array reference so ngOnChanges fires on the child
          // and clears the picker's loading skeleton even on a failed scroll
          // (search already resets to [] above, but scroll keeps the list).
          this.employeeList = [...this.employeeList];
          this.employeeLoading = false;
        }
      );
  }

  onEmployeeSearch(term: string) {
    this.employeePayload.searchContent = term || "";
    this.getEmployeeListForFilter(true);
  }

  onEmployeeScroll() {
    if (this.employeeStopScroll) return;
    this.employeePayload.searchAfterKey = this.employeePrevSearchAfterKey;
    this.getEmployeeListForFilter(false);
  }

  // Fired by app-job-filter-vertical-template when the SuperAdmin toggles
  // the "My Employees" checkbox ON. Lazily fetches the employee list at
  // that moment, with a fresh search/pagination state — guarantees the
  // user sees up-to-date employees every time they open the picker.
  onMyEmployeesToggled() {
    this.employeePayload.searchContent = "";
    this.employeePayload.searchAfterKey = null;
    this.employeePrevSearchAfterKey = null;
    this.employeeStopScroll = false;
    this.getEmployeeListForFilter(true);
  }

  isItemDisabled(item: any): boolean {
    return item.disabled;
  }



  searchUsers() {
    clearTimeout(this.searchTimeout);
    if (!this.searchNameorEmail || this.searchNameorEmail.trim().length === 0) {
      this.resetpayload();
      // this.isLoading = false;
      // this.jobFilterwithPagenation();

      this.isLoading = true;
      this.searchText.next('');
      return;
    }

    if (!this.isValidInput(this.searchNameorEmail)) {
      return;
    }

    this.resetpayload();
    this.searchTimeout = setTimeout(() => {
      this.payload.searchContent = this.searchNameorEmail;
      // this.isLoading = false;
      // this.jobFilterwithPagenation();

      this.isLoading = true;
      this.searchText.next('');
      console.log("Searching for:", this.searchNameorEmail);
    }, 300);
  }

  showError = false;
  TransferUser() {
    if(!this.selectedUserObj){
      this.showError = true;
      return;
    } 
    

    // this.userPayload.businessId = this.businessData.id;
    this.TransferPayload.organisationId = this.businessData.organisationId;
     this.showError = false;
    if (this.TransferPayload.targetUserId) {
      this.util.startLoader();
      this.api.create('jobs/jobTransfer', this.TransferPayload).subscribe(response => {
        this.userList = response?.data?.customerUserAllocationList;
        this.util.stopLoader();
        this.closeModal();

        if (response.code === "00000") {
          this.resetpayload();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Job transfer successfully",
            showConfirmButton: false,
            timer: 4000,
          })
          this.TransferPayload={};
          this.jobFilterwithPagenation();
        } else {
          Swal.fire({
            position: "center",
            icon: "info",
            title: "Job transfer not updated!",
            showConfirmButton: false,
            timer: 2000,
          })
        }

      });
    } else {
      this.showError = true;
    }

  }


  saveFilter() {
    this.resetpayload();
    console.log('Apply Filter:', this.selectedUser);
    this.payload.status = this.selectedstatus;
    this.jobFilterwithPagenation();
  }

  // Total count of currently-applied filters. Drives the colored highlight
  // and count badge on the "All Filters" button.
  getActiveFilterCount(): number {
    let count = 0;
    if (!this.payload) return 0;
    count += (this.payload.status || []).length;
    count += (this.payload.clientType || []).length;
    count += (this.payload.engagementType || []).length;
    count += (this.payload.workMode || []).length;
    count += (this.payload.publishedBy || []).length;
    count += (this.payload.userTypes || []).length;
    count += (this.payload.businessNetworks || []).length;
    count += (this.payload.memberNetworks || []).length;
    if (this.payload.city) count++;
    if (this.payload.state) count++;
    if (this.payload.country) count++;
    if (this.payload.zipCode) count++;
    if ((this.payload.experienceFrom > 0) || (this.payload.experienceTo > 0)) count++;
    if ((this.payload.postedFrom > 0) || (this.payload.postedTo > 0)) count++;
    return count;
  }

  // Open the slide-out "All Filters" panel (uses jobService toggle subject)
  openFilterSlider() {
    // Re-clicking while the panel is already open would re-push the stored
    // snapshot through setDataForFilter and re-hydrate the filter template
    // on top of edits the user is in the middle of making.
    if (this.isFilterOpen) return;
    this.isFilterOpen = true;
    this.JobServicecolor.setDataForFilter(this.tempFilterChanges || {});
    this.JobServicecolor.setSliderToggle(true, 'jobs', null, false);
  }

  // Slider host's Apply/close button. THIS is when we actually reload data.
  // Header-bar Reset button. Clears the vertical filter's UI state, then
  // routes through the existing onFilterToggle('reset') flow so the payload
  // and pagination reset and findOrgJobs is re-called.
  @ViewChild(JobFilterVerticalTemplateComponent) jobFilterRef?: JobFilterVerticalTemplateComponent;
  onResetFilters() {
    // Order matters: resetFilterDefault() internally calls
    // jobsouceCheckedAll(false) which un-ticks every source checkbox.
    // We must run it FIRST and then resetOrgJobsFilterUiState() LAST so
    // the SuperAdmin defaults (My Jobs + My Employees pre-tick, Status
    // all-ticked) survive the reset — otherwise jobsouceCheckedAll
    // wipes the re-tick that resetOrgJobsFilterUiState applied.
    this.jobFilterRef?.resetFilterDefault();
    this.jobFilterRef?.resetOrgJobsFilterUiState();
    this.onFilterToggle('reset');
    // Picker refetch handled inside onFilterToggle('reset') so the
    // slider footer Reset path gets the same treatment (it bypasses
    // onResetFilters and goes straight to onFilterToggle via the
    // slider's emit).
  }

  // Mirrors new-job.component pattern: clickHandler stores snapshot,
  // valuesRetainedForFilters event triggers reload.
  onFilterToggle(value: any) {
    this.isFilterOpen = false;
    if (value === 'reset') {
      this.resetpayload();
      this.payload.userId = this.userId;
      this.payload.organisationId = this.businessData.organisationId;
      this.tempFilterChanges = {};
      this.jobFilterwithPagenation(true);
      // Re-fetch the employee picker list with cleared search state.
      // Mirrors the onMyEmployeesToggled flow exactly — resets the
      // employee payload (searchContent, pagination) and refires
      // findEmployeeList. Covers BOTH header Reset and slider footer
      // Reset paths which both funnel through here.
      this.onMyEmployeesToggled();
      return;
    }
    this.applyFilterChangesToPayload();
    this.response = [];
    this.payload.searchAfterKey = null;
    this.lastSearchAfterKey = null;
    this.scrollEnable = true;
    this.jobFilterwithPagenation(true);
  }

  // Called by app-job-filter-vertical-template on every internal change via
  // filterConfig.clickHandler. We only STORE the snapshot here. The actual
  // API reload happens on Apply (onFilterToggle).
  onFilterChange(data: any) {
    if (!data) return;
    this.tempFilterChanges = data;
  }

  // Map the stored tempFilterChanges into payload fields (OrgJobFilterValues shape).
  // Called from onFilterToggle (Apply) — never from onFilterChange.
  private applyFilterChangesToPayload() {
    const data = this.tempFilterChanges || {};
    const form = data.formData || {};

    this.payload.status = (data.statusCheckedItems || [])
      .filter(x => x.selected && x.label !== 'All')
      .map(x => x.label);

    this.payload.engagementType = (data.jobClassifications || [])
      .filter(x => x.selected && x.label !== 'All')
      .map(x => x.label);

    this.payload.clientType = (data.clientTypeCheckedItems || [])
      .filter(x => x.selected && x.label !== 'All')
      .map(x => x.label);

    this.payload.workMode = (data.workMode || [])
      .filter(x => x.selected && x.label !== 'All')
      .map(x => x.label);

    this.payload.city = form.city || '';
    this.payload.state = form.state || '';
    this.payload.country = form.country || '';
    this.payload.zipCode = form.zipCode || '';

    this.payload.experienceFrom = form.experienceFrom != null ? form.experienceFrom : 0;
    this.payload.experienceTo = form.experienceTo != null ? form.experienceTo : 0;

    this.payload.postedFrom = form.postedFrom != null ? form.postedFrom : 0;
    this.payload.postedTo = form.postedTo != null ? form.postedTo : 0;

    // SuperAdmin Job Source variant feeds publishedBy from two checkboxes:
    // - "My Jobs" (formData.source[0].myJobs) → include the SuperAdmin's own userId
    // - "My Employees" picker (selectedEmployees) → include each picked employee userId
    // Both compose with the existing publishedByUsers (always empty in orgJobsMode
    // since the Published By sub-list is hidden, but kept for safety).
    const sourceFlags = (data.formData?.source || [])[0] || {};
    const myJobs = !!sourceFlags.myJobs;
    const myEmployees = !!sourceFlags.myEmployees;
    const employeeIds = data.selectedEmployees || [];
    const publishedByLegacy = data.publishedByUsers || [];

    // publishedBy construction
    //   * "My Jobs + My Employees + no picks" → keep publishedBy empty
    //     so the backend interprets it as "everything in org" (SA + all
    //     employees). The backend's SA-exclusion is gated on
    //     !myJobsMode, so SA stays in the results.
    //   * Any other combination → include the logged-in user's id from
    //     My Jobs and the explicitly picked employee ids.
    if (myJobs && myEmployees && employeeIds.length === 0) {
      this.payload.publishedBy = Array.from(new Set([...publishedByLegacy]));
    } else {
      const myJobsIds = myJobs && this.userId ? [this.userId] : [];
      // Only fold employee picks in while "My Employees" is actually on.
      // When it's unchecked, ignore any lingering picks so a previously
      // selected employee no longer filters the results.
      const empIds = myEmployees ? employeeIds : [];
      this.payload.publishedBy = Array.from(new Set([...publishedByLegacy, ...myJobsIds, ...empIds]));
    }

    this.payload.businessNetworks = data.businessNetworks || [];

    // Both source flags travel to the backend so it can decide whether
    // to apply the SA-exclusion (only when myEmployees && !myJobs &&
    // publishedBy is empty — the "My Employees alone, no picks" case).
    this.payload.myEmployeesMode = myEmployees;
    this.payload.myJobsMode = myJobs;
  }





  // Filters  Coding
  filterbyRole(user, type) {
    const roleMap = {
      jobs: [GigsumoConstants.RECRUITER, GigsumoConstants.FREELANCE_RECRUITER, GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION],
      candidates: [GigsumoConstants.BENCH_RECRUITER, GigsumoConstants.FREELANCE_RECRUITER, GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION]
    };

    return user.filter(item => roleMap[type]?.includes(item.userType));
  }


  @Output() parentValueChange = new EventEmitter<any>();
  pushtoparentcomponent(selectedItem) {
    const index = this.response.findIndex(item => item.jobId == selectedItem.jobId);
    if (selectedItem.isSelected) {
      this.response[index].transferJob = true;
    } else {
      this.response[index].transferJob = false;
      this.selecteAllFlag = false;

    }
  }

  selecteAll(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.selecteAllFlag = isChecked;
    this.response = this.response.map(item => ({
      ...item,
      transferJob: isChecked,
      isSelected: isChecked
    }));
  }

  // Toggle selection mode for row-design view
  toggleSelectionMode() {
    this.selectionMode = !this.selectionMode;
    // Clear selections when exiting selection mode
    if (!this.selectionMode) {
      this.selecteAllFlag = false;
      this.response = this.response.map(item => ({
        ...item,
        transferJob: false,
        isSelected: false
      }));
    }
  }


  // User Letter Update profile
  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }

  toggleSelection(item: any) {
    item.selected = !item.selected;
    console.log("Selection toggled for:", item.fullName, "New State:", item.selected);
  }



  onScrollDown() {
    if (this.scrollEnable || !this.isLoading) {
      if (JSON.stringify(this.payload.searchAfterKey) !== JSON.stringify(this.lastSearchAfterKey)) {
        this.jobFilterwithPagenation();
      }
    }
  }


  reponseChildtoParent(value) {
    this.selecteAllFlag = this.selecteAllFlag ? value.flag : value.response.every(el => el.transferJob === true);
  }

  onDropdownChange() {
    // console.log('Selected Filter:', this.selectedUser);
    if(this.payload.status.length > 0){
      this.resetpayload();
      this.payload.status = this.selectedstatus;
      this.jobFilterwithPagenation();
    }
  }

  // Filter helper methods
  isStatusSelected(value: string): boolean {
    return this.selectedstatus.includes(value);
  }

  toggleStatusFilter(value: string, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      if (!this.selectedstatus.includes(value)) {
        this.selectedstatus = [...this.selectedstatus, value];
      }
    } else {
      this.selectedstatus = this.selectedstatus.filter(s => s !== value);
    }
  }

  clearAllFilters(): void {
    this.selectedstatus = [];
  }

  countforEnable() {
    return this.response.filter(item => item.transferJob === true).map(item => item.jobId).length
  }

  onSelectionChange(event: any) {

    if (!event) {
      this.TransferPayload={};
      this.selectedUserObj = null;

    }
  }

  selectedUserObj : any;
  selectUser(item: any) {
    console.log("Selected User:", item);
    this.selectedUserObj = item;
    const selected = this.response.filter(item => item.transferJob === true);
    const hasCurrentUserJobs = selected.some(i => i.jobPostedBy === item.userId);
    const hasOtherUserJobs = selected.some(it => it.jobPostedBy !== item.userId);

    let proceedAnotherSelection = hasCurrentUserJobs && hasOtherUserJobs;
    if(hasCurrentUserJobs){
      let msg = proceedAnotherSelection
        ? 'You have selected a job assigned to yourself. Do you want to remove it and proceed with transferring other jobs?'
        : 'You have selected jobs that are already assigned to this user.';

      Swal.fire({
        position: "center",
        icon: "warning",
        title: msg,
        showCancelButton: true,
        confirmButtonText: "Remove & Proceed",
        cancelButtonText: "Select Another User",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
        allowEscapeKey: false,
        reverseButtons: true,
        showConfirmButton : proceedAnotherSelection  
      }).then((result) => {
        if (result.isConfirmed) {
          if(hasOtherUserJobs){
            this.showError = false;   
            this.response = this.response.map(item => ({
              ...item,
              transferJob: item.jobPostedBy === this.selectedUserObj.userId ? false : item.transferJob,
              isSelected: item.jobPostedBy === this.selectedUserObj.userId ? false : item.transferJob
            }));
          
            const jobIdArray = this.response.filter(item => item.transferJob === true).map(item => item.jobId);
            this.showError = false; 
            this.TransferPayload = {
              "targetUserId": this.selectedUserObj.userId,
              "jobs": jobIdArray
              
            }  
            
            this.userList = this.userList.map(item => ({
              ...item,
              disabled: this.checkUserForEnable(item)
            }));
            
          }else {
            this.selectedUser = null;
            this.showError = true;
          }
        } else {
          this.selectedUser = null;
          this.showError = true;
         }
      }); 

    }else{
      this.selectedUser = item.userId;
      this.showError = false;
      const jobIdArray = this.response.filter(item => item.transferJob === true).map(item => item.jobId);
      this.showError = false;
      this.TransferPayload = {
        "targetUserId": item.userId,
        "jobs": jobIdArray
      }
     }


  }

  isValidInput(text: string): boolean {
    // Only enforce a minimum length so we don't fire searches on a single
    // character. Character set is intentionally NOT restricted — users may
    // legitimately search for titles/skills containing +, /, #, &, etc.
    // (e.g. ".Net + XAMARIN + AZURE", "C++", "Node.js", "Pre-Sales & Marketing").
    // Backend handles whatever is typed via Elasticsearch matchQuery / wildcardQuery.
    return !!text && text.trim().length >= 3;
  }

  restrictSpecialChars(event: KeyboardEvent) {
    // Allow letters, digits, spaces, and common chars seen in titles/skills/
    // job IDs (. _ - + & / # @). Block characters that could break the ES
    // wildcard syntax (* ? \).
    const charCode = event.key;
    if (charCode.length > 1) return; // allow control keys (Backspace, Arrow, Enter, etc.)
    const validPattern = /^[a-zA-Z0-9@\s._\-+&\/#]+$/;
    if (!validPattern.test(charCode)) {
      event.preventDefault();
    }
  }


  resetpayload() {
    this.response = [];
    this.showError = false;
    this.scrollEnable = true;
    this.selecteAllFlag = false;
    this.payload = {
      "limit": 10,
      "searchAfterKey": null,
      "searchContent": "",
      "status": [],
      "organisationId": "",
      "clientType": [],
      "engagementType": [],
      "workMode": [],
      "city": "",
      "state": "",
      "country": "",
      "zipCode": "",
      "experienceFrom": 0,
      "experienceTo": 0,
      "postedFrom": 0,
      "postedTo": 0,
      "publishedBy": [],
      "userTypes": [],
      "businessNetworks": [],
      "memberNetworks": []
    };
  }

  // Modal actions and API call
  isModalOpen = false;
  private onHiddenSub: any = null;
  openModel(template: TemplateRef<any>) {
    this.userListAPI();
    // Drop any leftover subscription from a previous open/close cycle so the
    // old callback can't fire AFTER the new modal has been shown — that race
    // was what made the next openModel throw "Cannot read properties of null".
    if (this.onHiddenSub) {
      this.onHiddenSub.unsubscribe?.();
      this.onHiddenSub = null;
    }
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
      // ngx-bootstrap appends config.class to its .modal-dialog element
      // (modal-container.component.js:125), giving us a selector that exists
      // ONLY while this dialog is open. The Transfer picker's ng-select
      // targets it with appendTo=".gs-transfer-modal" so its dropdown panel
      // renders as a sibling of .modal-content — outside the `overflow:
      // hidden` that leaks onto every .modal-content from the company-*
      // components' unscoped `::ng-deep .modal-content` rules (so the list
      // isn't clipped), yet still inside the position:fixed modal (so the
      // panel stays glued to its field when the page behind scrolls).
      // A unique class is required: appendTo=".modal-dialog" resolves via
      // document.querySelector and would match the FIRST .modal-dialog in the
      // document — including the permanently-hidden price-plan host modal
      // (styles.scss:4303), which swallowed the panel entirely.
      class: "gs-transfer-modal",
    });
    this.isModalOpen = true;
    // Hook onHidden ONLY to patch body styles — never to remove DOM nodes.
    // ngx-bootstrap owns <modal-container> / .modal-backdrop; removing those
    // desyncs its internal state and breaks the next show().
    this.onHiddenSub = this.modalRef?.onHidden?.subscribe(() => this.restoreBodyScrollState());
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.selectedUser = null;
    this.isModalOpen = false;
    this.showError = false;
    this.TransferPayload = {};
    this.selectedUserObj = null;
  }

  // Body-style patch only — does NOT touch ngx-bootstrap-managed DOM nodes.
  // Runs from onHidden (after the hide animation completes and ngx-bootstrap
  // has already finished its own teardown) and from ngOnDestroy.
  private restoreBodyScrollState() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.classList.remove('modal-open');
  }

  ngOnDestroy() {
    if (this.onHiddenSub) {
      this.onHiddenSub.unsubscribe?.();
      this.onHiddenSub = null;
    }
    this.restoreBodyScrollState();
    this.scrollResetSub?.unsubscribe();
    this.listSub?.unsubscribe();
  }


  getjobId(item) {
    console.log("Click Event",item)
   }
}
